import { Pipe, PipeTransform } from '@angular/core';
import { normalizeCuitRaw } from '../helpers/cuit.util';

@Pipe({
	name: 'cuit',
	standalone: true,
})
export class CuitPipe implements PipeTransform {
	transform(value?: string | number | null): string {
		const normalized = normalizeCuitRaw((value ?? '').toString());
		if (normalized.length !== 11) return '';
		return `${normalized.slice(0, 2)}-${normalized.slice(2, 10)}-${normalized.slice(10)}`;
	}
}
